import {
  declareString,
  declareStringWithPlaceholders,
} from "@1js/localization";

export const DetailProductDescription = declareString(
  "promptLibrary.promptDetailProductDescription",
  {
    text: "Works in",
    comment: `Description that appears next to product badges in prompt detail. The description category is appended with one or more product names for which the Copilot prompt would work. e.g.: "Works in Microsoft 365 Chat, Word"`,
  }
);

export const DetailProductDescriptionAlsoWorksIn = declareString(
  "promptLibrary.promptDetailProductDescriptionAlsoWorksIn",
  {
    text: "Also works in",
    comment: `Description that appears next to product badges in prompt detail. The description category is appended with one or more product names for which the Copilot prompt can be tried in. e.g.: "Works also in Microsoft 365 Chat, Word"`,
  }
);

export const DetailProductDescriptionAlsoWorksInInfoLabel = declareString(
  "promptLibrary.promptDetailProductDescriptionAlsoWorksInInfoLabel",
  {
    text: "In some apps, you’ll need to copy and paste the prompt into Copilot.",
    comment: `Info label displayed next to DetailProductDescriptionAlsoWorksIn when user clicks on an Info-button.`,
  }
);

export const DetailProductDescriptionUninstalledAgentHelpLink = declareString(
  "promptLibrary.DetailProductDescriptionUninstalledAgentHelpLink",
  {
    text: "The agent this prompt works in is no longer installed",
    comment: `Text that appears as a link in the prompt detail page when the user clicks on a prompt that is related to an agent that is no longer installed.`,
  }
);

export const DetailDisplayCategoryDescription = declareString(
  "promptLibrary.promptDetailDisplayCategoryDescription",
  {
    text: "Category",
    comment: `Description that appears when the user opens a Prompt. The category label will be found next to the category related to that prompt (e.g.: Create, Edit, Catch up, etc.).`,
  }
);

export const DetailTagDescription = declareString(
  "promptLibrary.promptDetailTagDescription",
  {
    text: "Tag",
    comment: `Description that appears when the user opens a Prompt. The tag label will be found next to the tag related to that prompt (e.g.: New, SDF, etc.).`,
  }
);

export const CloseTooltip = declareString("promptLibrary.closeTooltip", {
  text: "Close",
  comment: `Tooltip that appears when the user hovers close buttons in prompt details page.`,
});

export const ExtensionPromptDescriptionInfoLabel =
  declareStringWithPlaceholders(
    "promptLibrary.ExtensionPromptDescriptionInfoLabel",
    {
      text: ({ extensionName }) =>
        `Copy and paste this prompt into Copilot and make sure ${extensionName} is selected before submitting it.`,
      placeholders: {
        extensionName: "The name of the extension installed for user",
      },
      comment: `Info label displayed next to DetailProductDescriptionAlsoWorksIn when user clicks on an Info-button for extension prompt.`,
    }
  );
